import axios from 'axios';
import { saveAs } from 'file-saver';

// gcs上のファイルダウンロード
export async function DownloadFile(url:string, fileName: string) {
    console.log("hoge:"+url)
    const res = await axios.get(url, {responseType:"blob"});

    if (fileName.endsWith(".mp3") || fileName.endsWith(".wav"))
    {
        const blob = await new Blob([res.data], {type:"audio/mpeg"});
        saveAs(blob, fileName);
    }
    else
    {
        saveAs(res.data, fileName);
    }
}